<script>
import api from "../axios.js";
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
import AcceptTermsCheckbox from "@/components/AcceptTermsCheckbox.vue";
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    AcceptTermsCheckbox,
  },
  data() {
    return {
      email: "",
      password: "",
      role: "student",
      error: "",
      success: "",
      acceptedTerms: false,
    };
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  methods: {
    ...mapActions(["login"]),
    async register() {
      if (!this.acceptedTerms) {
        this.error = `${this.t("errors.acceptTermsRegister")}.`;
        this.success = "";
        return;
      }

      try {
        const res = await api.post(`${apiBaseUrl}/auth/register`, {
          email: this.email,
          password: this.password,
          role: this.role,
          acceptedTerms: this.acceptedTerms, // Skicka med acceptans
        });

        this.success = "Registrering lyckades!";
        this.error = "";

        const token = res.data.token;

        const studentProfile = await api.get(`${apiBaseUrl}/students/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        await this.login({
          token,
          user: studentProfile.data,
        });

        this.$router.push("/profile");
      } catch (err) {
        this.error =
          this.t(`errors.register.${err.response?.data?.message}`) || //Jag fick "undefined" här på errors.register.undefined när StudentModel var fel
          this.t("errors.register.default");
        this.success = "";
      }
    },
  },
};
</script>

<template>
  <v-container class="mt-16">
    <h2>{{ t("login.register") }}</h2>
    <v-form @submit.prevent="register">
      <v-text-field
        v-model="email"
        type="email"
        :placeholder="t('profile.email')"
        required
      />
      <v-text-field
        v-model="password"
        type="password"
        :placeholder="t('login.password')"
        required
      />

      <AcceptTermsCheckbox v-model="acceptedTerms" color="primary" />

      <v-btn type="submit">{{ t("login.register") }}</v-btn>
    </v-form>

    <p v-if="error" style="color: red">{{ error }}</p>
    <p class="mt-4">
      {{ t("login.accountExist") }}
      <router-link
        to="/login"
        style="color: blue; cursor: pointer; text-decoration: underline"
      >
        {{ t("login.loginHere") }}
      </router-link>
    </p>
  </v-container>
</template>
